import styled from 'styled-components';
import CarbonButton from '@web/components/Shared/Button';
import Tooltip from 'carbon-react/lib/components/tooltip';
import I18n from 'i18n-js';

const Button = styled(CarbonButton)`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 42px;
  width: 40px;
  color: ${({ theme }) => theme.colors.white};
  border-color: transparent;
  background-color: ${({ theme }) => theme.palette.black};

  &:hover,
  &:focus {
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.palette.blackTint(37)};
  }

  & span {
    color: ${({ theme }) => theme.colors.white} !important;
  }
`;

export const HelpButton = () => {
  return (
    <Tooltip message={I18n.t('navigation.HelpTooltipMessage')}>
      <Button data-pendo-id="help" href={import.meta.env.VITE_APP_HELP_URL} target="_blank" iconType="help" />
    </Tooltip>
  );
};
